module.exports = __webpack_public_path__ + "img/history_blue_icon.65b19753.svg";